import { motion } from "framer-motion";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { fadeInUp, scaleIn } from "utils/motionPresets";

const Page404: React.FC = () => (
  <div className="nc-Page404 min-h-[60vh] flex items-center">
    <Helmet>
      <title>404 || BCR LTD. UK</title>
      <meta name="description" content="The page you are looking for cannot be found. Please check the URL or return to the BCR Ltd homepage." />
    </Helmet>
    <div className="container relative py-16 lg:py-24">
      <motion.header
        className="text-center max-w-2xl mx-auto space-y-6"
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
      >
        <motion.div variants={scaleIn}>
          <span className="text-8xl md:text-9xl font-bold bcr-gradient-text">404</span>
        </motion.div>
        <h1 className="text-2xl md:text-3xl font-bold text-neutral-900 dark:text-neutral-100">
          Page Not Found
        </h1>
        <p className="text-neutral-500 dark:text-neutral-400 text-base md:text-lg">
          The page you were looking for doesn't exist or has been moved.
        </p>
        <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center">
          <ButtonPrimary href="/">Return Home</ButtonPrimary>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-8 py-3.5 text-sm font-semibold rounded-full border-2 border-primary-500 text-primary-600 dark:text-primary-400 hover:bg-primary-50 dark:hover:bg-primary-900/20 transition-all duration-300"
          >
            Contact Us
          </Link>
        </div>
      </motion.header>
    </div>
  </div>
);

export default Page404;
